// Standing notes shown across the assessment result, work packet and PDF views.
// Kept in one place so the wording stays identical everywhere it appears.

// What the EESA does and does not measure (shown on result and work packet screens and PDFs).
export const EESA_SCOPE_NOTE =
    'The EESA measures syllable shape and number, not articulation accuracy. A high score does not mean the learner produces the speech sounds correctly.';

// How to set up before recording a test item.
export const RECORDING_SETUP_NOTE =
    'Record in a quiet room with the microphone close to the child (about 6-12 inches) and keep background noise down - transcription accuracy depends on the recording.';

// What the colours mean on the test item, per entry style.
export const PHONEME_COLOUR_LEGEND =
    'Purple = not scored yet, green = correct, red = incorrect. Click a sound to change it.';

export const SYLLABLE_COUNT_LEGEND =
    'Tick each syllable the learner produced. Groups 4 and 5 score the number of syllables, not articulation accuracy, so nothing is marked wrong until you mark it.';

// The 1 / half / 0 rule for each group, said in plain English, from the EESAPP
// Guide, 2nd ed. (overview table p.28; group tables p.30-33). The scoring
// legend above it reads as three rows, which hides the "or" in the half rule.
const HALF_RULE_GROUPS_2_3 =
    'Half a point: the vowels the learner said are correct AND some consonants are missing or wrong, OR the number of syllables is wrong.';

export const SCORING_RULE_NOTES = {
    1: 'One point: the vowels the learner said are correct, any consonant is included (it does not have to be the right one) and the number of syllables matches. Half a point: the vowels are correct AND a consonant is omitted, OR the number of syllables is wrong. Nought: a vowel is wrong, or there is no response.',
    2: `One point: the vowels and all the consonants are correct and the number of syllables matches. ${HALF_RULE_GROUPS_2_3} Nought: a vowel is wrong, all the modelled consonants are omitted, or there is no response.`,
    3: `One point: the vowels and all the consonants are correct and the number of syllables matches. ${HALF_RULE_GROUPS_2_3} Nought: a vowel is wrong, all the modelled consonants are omitted, or there is no response.`,
    4: 'One point if the number of syllables repeated matches the model, nought if it does not. Articulation errors and word order are not scored, and there is no half point in Groups 4 and 5.',
    5: 'One point if the number of syllables repeated matches the model, nought if it does not. Articulation errors and word order are not scored, and there is no half point in Groups 4 and 5.',
};

export const SCORING_RULE_REF = 'EESAPP Guide, 2nd ed., p.28 and p.30-33';

export function scoringRuleNote(groupId) {
    return SCORING_RULE_NOTES[groupId] || '';
}
